export const OrderTableHeaders=[
    {
        Header:'Receipt#',
        accessor:'orderNumber'
    },
    {
        Header:'Name',
        accessor:'name'
    },
    {
        Header:'Last Name',
        accessor:'lastname'
    },
    {
        Header:'Phone',
        accessor:'phone'
    }, 
    {
        Header:'Order Date',
        accessor:'startDate'
    },
    {
        Header:'Event Date',
        accessor:'eventDate'
    },
    {
        Header:'description',
        accessor:'description'
    },
    {
        Header:'Num of Items',
        accessor:'numOfItems'
    },
    {
        Header:'Deposit',
        accessor:'deposit'
    }

]